import tree from "../../../components/tree.vue"
import iColumn from "../../../components/Column.vue";
import iTable from "../../../components/Table.vue";
import IPagination from "../../../components/pagination.vue";
import moment from 'moment';
import { domainName } from "../../../utility/index"

export default {
  name: "userManagement",
  components: { tree, iColumn, iTable, IPagination },
  data() {
    return {
      formInline: {
        data: [],
        orgId: '',
      },
      orgIdList: [],
      columnList: [],
      tableData: [],
      displayRange: {
        start: 0,
        end: 50,
      },
      spanArr: [],

      loading: false,
      loadingMore: false,
      pageSize: 50,
      hasMore: true,
      tableHeight: '',

      scrollTimer: null,
      isScrolling: false,

      orgNameIndex: -1,
      orgBelowNameIndex: -1,
      carCountIndex: -1,
    };
  },
  computed: {
    displayData() {
      return this.tableData.slice(this.displayRange.start, this.displayRange.end);
    }
  },
  created() {
    this.getDate()
    this.getOrg()
  },
  mounted() {
    this.getData()

    window.addEventListener('resize', this.handleResize);
    this.handleResize();

    this.$nextTick(() => {
      this.bindTableScroll();
    });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
    if (this.scrollTimer) {
      clearTimeout(this.scrollTimer);
    }
  },
  methods: {
    getDate() {
      const endTime = moment().subtract(1, "day").format("YYYY-MM-DD");
      const startTime = moment().subtract(1, "month").format("YYYY-MM-DD");
      this.formInline.data = [startTime, endTime];
    },
    getOrg() {
      this.$store.dispatch('tree/GET_SELECTUSERORG').then(res => {
        if (res) {
          if (res.data.code == 200) {
            this.orgIdList = res.data.data
          }
        }
      })
    },
    setClass({ row, column, rowIndex, columnIndex }) {
      const length = this.displayData.length - 2
      if (columnIndex <= this.displayData.length - length) {
        return 'addBorder'
      }
    },
    bindTableScroll() {
      const tableWrapper = this.$refs.dataTable?.$el?.querySelector('.el-table__body-wrapper');
      if (tableWrapper) {
        tableWrapper.addEventListener('scroll', this.handleTableScroll);
      }
    },
    handleTableScroll(event) {
      if (this.loadingMore || !this.hasMore || this.tableData.length === 0) {
        return;
      }

      // 防抖处理
      if (this.scrollTimer) {
        clearTimeout(this.scrollTimer);
      }

      this.scrollTimer = setTimeout(() => {
        const tableWrapper = event.target || this.$refs.dataTable?.$el?.querySelector('.el-table__body-wrapper');
        if (!tableWrapper) return;

        // 计算是否滚动到底部
        const scrollTop = tableWrapper.scrollTop;
        const scrollHeight = tableWrapper.scrollHeight;
        const clientHeight = tableWrapper.clientHeight;

        // 距离底部100px时加载更多
        if (scrollHeight - scrollTop - clientHeight < 100) {
          this.loadMore();
        }
      }, 200);
    },
    getSpanArr() {
      // 初始化spanArr
      const rowCount = this.displayData.length;
      const colCount = this.columnList.length + 1;
      this.findColumnIndexes();
      // 初始化所有单元格为不合并
      this.spanArr = new Array(rowCount * colCount).fill().map(() => ({
        rowspan: 1,
        colspan: 1,
      }));

      if (rowCount <= 1) return; // 数据不足，不需要合并

      // 1. 首先根据"组织名称"列进行合并
      this.mergeOrgNameColumn(colCount);
      this.mergeOrgBelowNameColumn(colCount);
      // 2. 然后根据"车辆总数"列进行合并
      this.mergeCarCountColumn(colCount);
    },

    findColumnIndexes() {
      this.orgNameIndex = -1;
      this.orgBelowNameIndex = -1;
      this.carCountIndex = -1;

      // 遍历columnList找到各列所在的索引
      this.columnList.forEach((item, index) => {
        // 优先通过prop匹配
        if (item.prop === "orgName") {
          this.orgNameIndex = index + 1; // +1是因为有序号列
        } else if (item.prop === "orgBelowName") {
          this.orgBelowNameIndex = index + 1;
        } else if (item.prop === "driverCount") {
          this.carCountIndex = index + 1;
        }

        // 如果通过prop没找到，尝试通过label匹配
        // if (item.label) {
        //   if (item.label.includes("组织名称") || item.label.includes("组织管理")) {
        //     if (this.orgNameIndex === -1) this.orgNameIndex = index + 1;
        //   } else if (item.label.includes("车辆总数")) {
        //     if (this.carCountIndex === -1) this.carCountIndex = index + 1;
        //   }
        // }
      });
    },
    mergeOrgNameColumn(colCount) {
      if (this.orgNameIndex === -1) return;

      const rowCount = this.displayData.length;
      let row = 0;

      // console.log('开始合并组织名称列，索引:', this.orgNameIndex);

      while (row < rowCount) {
        let currentRow = row;
        let spanCount = 1;

        // 计算相同组织名称的行数
        while (currentRow + spanCount < rowCount &&
          this.displayData[currentRow].orgName === this.displayData[currentRow + spanCount].orgName) {
          spanCount++;
        }

        // 如果有多行可以合并
        if (spanCount > 1) {
          // 设置第一行的合并信息
          this.spanArr[currentRow * colCount + this.orgNameIndex] = {
            rowspan: spanCount,
            colspan: 1,
          };

          // 将后面合并的行设置为隐藏
          for (let i = 1; i < spanCount; i++) {
            this.spanArr[(currentRow + i) * colCount + this.orgNameIndex] = {
              rowspan: 0,
              colspan: 0,
            };
          }

          // console.log(`合并组织名称: ${this.tableData[currentRow].orgName}, 行数: ${spanCount}`);
        }

        row += spanCount;
      }
    },

    // 合并组织管理第二列
    mergeOrgBelowNameColumn(colCount) {
      if (this.orgBelowNameIndex === -1) {
        // console.log('未找到orgBelowName列，跳过合并');
        return;
      }

      const rowCount = this.displayData.length;
      let row = 0;

      // console.log('开始合并组织管理第二列，索引:', this.orgBelowNameIndex);

      while (row < rowCount) {
        let currentRow = row;

        // 跳过已经被合并的行
        const cellIndex = currentRow * colCount + this.orgBelowNameIndex;
        if (this.spanArr[cellIndex].rowspan === 0) {
          row++;
          continue;
        }

        // 获取当前行的组织名称
        const currentOrgName = this.displayData[currentRow].orgName;
        const currentOrgBelowName = this.displayData[currentRow].orgBelowName;

        // console.log(`检查第${currentRow}行: orgName=${currentOrgName}, orgBelowName=${currentOrgBelowName}`);

        // 查找同一组织名称组内的所有行
        let orgRows = [];
        for (let i = currentRow; i < rowCount && this.displayData[i].orgName === currentOrgName; i++) {
          // 只添加orgBelowName单元格未被合并的行
          if (this.spanArr[i * colCount + this.orgBelowNameIndex].rowspan !== 0) {
            orgRows.push(i);
          }
        }

        // console.log(`组织 ${currentOrgName} 的行索引:`, orgRows);

        // 在同一个组织名称组内，按照orgBelowName进行合并
        if (orgRows.length > 1) {
          let startIdx = 0;

          while (startIdx < orgRows.length) {
            let mergeStartRow = orgRows[startIdx];
            let mergeCount = 1;
            const startOrgBelowName = this.displayData[mergeStartRow].orgBelowName;

            // 计算相同orgBelowName的行数
            for (let j = startIdx + 1; j < orgRows.length; j++) {
              if (this.displayData[orgRows[j]].orgBelowName === startOrgBelowName) {
                mergeCount++;
              } else {
                break;
              }
            }

            // 如果有多行orgBelowName相同，则合并
            if (mergeCount > 1) {
              this.spanArr[mergeStartRow * colCount + this.orgBelowNameIndex] = {
                rowspan: mergeCount,
                colspan: 1,
              };

              // 将后面合并的行设置为隐藏
              for (let i = 1; i < mergeCount; i++) {
                this.spanArr[(mergeStartRow + i) * colCount + this.orgBelowNameIndex] = {
                  rowspan: 0,
                  colspan: 0,
                };
              }

              // console.log(`合并orgBelowName: ${startOrgBelowName}, 行数: ${mergeCount}`);
            }

            startIdx += mergeCount;
          }
        }

        // 移动到下一个组织名称组
        if (orgRows.length > 0) {
          row += orgRows.length;
        } else {
          row++;
        }
      }
    },

    // 合并车辆总数列
    mergeCarCountColumn(colCount) {
      if (this.carCountIndex === -1) {
        // console.log('未找到车辆总数列，跳过合并');
        return;
      }

      const rowCount = this.displayData.length;
      let row = 0;

      // console.log('开始合并车辆总数列，索引:', this.carCountIndex);

      while (row < rowCount) {
        let currentRow = row;

        // 跳过已经被合并的行
        const cellIndex = currentRow * colCount + this.carCountIndex;
        if (this.spanArr[cellIndex].rowspan === 0) {
          row++;
          continue;
        }

        // 获取当前行的组织名称和orgBelowName
        const currentOrgName = this.displayData[currentRow].orgName;
        const currentOrgBelowName = this.displayData[currentRow].orgBelowName;
        const currentCarCount = this.displayData[currentRow].driverCount;

        // console.log(`检查第${currentRow}行: orgName=${currentOrgName}, orgBelowName=${currentOrgBelowName}, driverCount=${currentCarCount}`);

        // 查找同一组织名称和同一orgBelowName组内的所有行
        let groupRows = [];
        for (let i = currentRow; i < rowCount; i++) {
          // 检查是否属于同一组
          const sameOrgName = this.tableData[i].orgName === currentOrgName;
          const sameOrgBelowName = this.tableData[i].orgBelowName === currentOrgBelowName;

          if (sameOrgName && sameOrgBelowName) {
            // 只添加车辆总数单元格未被合并的行
            if (this.spanArr[i * colCount + this.carCountIndex].rowspan !== 0) {
              groupRows.push(i);
            }
          } else {
            break;
          }
        }

        // console.log(`组 ${currentOrgName}-${currentOrgBelowName} 的行索引:`, groupRows);

        // 在同一个组织和orgBelowName组内，按照车辆总数进行合并
        if (groupRows.length > 1) {
          let startIdx = 0;

          while (startIdx < groupRows.length) {
            let mergeStartRow = groupRows[startIdx];
            let mergeCount = 1;
            const startCarCount = this.tableData[mergeStartRow].driverCount;

            // 计算相同车辆总数的行数
            for (let j = startIdx + 1; j < groupRows.length; j++) {
              if (this.tableData[groupRows[j]].driverCount === startCarCount) {
                mergeCount++;
              } else {
                break;
              }
            }

            // 如果有多行车辆总数相同，则合并
            if (mergeCount > 1) {
              this.spanArr[mergeStartRow * colCount + this.carCountIndex] = {
                rowspan: mergeCount,
                colspan: 1,
              };

              // 将后面合并的行设置为隐藏
              for (let i = 1; i < mergeCount; i++) {
                this.spanArr[(mergeStartRow + i) * colCount + this.carCountIndex] = {
                  rowspan: 0,
                  colspan: 0,
                };
              }

              // console.log(`合并carCount: ${startCarCount}, 行数: ${mergeCount}`);
            }

            startIdx += mergeCount;
          }
        }

        // 移动到下一组
        if (groupRows.length > 0) {
          row += groupRows.length;
        } else {
          row++;
        }
      }
    },

    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        return {
          rowspan: 1,
          colspan: 1
        };
      }

      const colCount = this.columnList.length + 1; // 加上序号列
      return this.spanArr[rowIndex * colCount + columnIndex] || {
        rowspan: 1,
        colspan: 1
      };
    },

    handleResize() {
      const windowHeight = window.innerHeight;
      this.tableHeight = (windowHeight - 250) + 'px';

    },
    getData() {
      this.loading = true;
      let param = {
        userId: sessionStorage.getItem("userId"),
        orgId: this.formInline.orgId,
        startTime: this.formInline.data[0],
        endTime: this.formInline.data[1],
      }
      this.$store.dispatch('ReportAnalysis/GET_SELECTDRIVERHOMEWORKDETAILS', param).then(res => {
        if (res) {
          if (res.data.code == 200) {
            // this.tableData = res.data.data.list
            const rawData = res.data.data.list || [];
            this.columnList = res.data.data.label || [];

            this.processAndSortData(rawData);

            this.displayRange = {
              start: 0,
              end: Math.min(this.pageSize, this.tableData.length)
            };

            // 更新是否有更多数据
            this.hasMore = this.displayRange.end < this.tableData.length;
            this.getSpanArr()

            this.$nextTick(() => {
              this.$refs.dataTable?.doLayout?.()
            })
            // this.$refs.page.CommandTotal = res.data.data.total
          }
        }
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    },

    processAndSortData(rawData) {
      this.tableData = rawData;
      if (this.tableData && this.tableData.length > 0) {
        this.tableData.sort((a, b) => {
          if (a.orgName < b.orgName) return -1;
          if (a.orgName > b.orgName) return 1;

          const aOrgBelowName = a.orgBelowName || '';
          const bOrgBelowName = b.orgBelowName || '';
          if (aOrgBelowName < bOrgBelowName) return -1;
          if (aOrgBelowName > bOrgBelowName) return 1;

          const aCarCount = a.driverCount === undefined || a.driverCount === null ? '' : a.driverCount;
          const bCarCount = b.driverCount === undefined || b.driverCount === null ? '' : b.driverCount;

          if (aCarCount < bCarCount) return -1;
          if (aCarCount > bCarCount) return 1;

          return 0;
        });
      }
    },

    // 加载更多数据
    loadMore() {
      if (this.loadingMore || !this.hasMore || this.tableData.length === 0) {
        return;
      }
      this.loadingMore = true;

      setTimeout(() => {
        const newEnd = Math.min(this.displayRange.end + this.pageSize, this.tableData.length);
        this.displayRange.end = newEnd;
        this.hasMore = newEnd < this.tableData.length;
        this.getSpanArr();

        this.loadingMore = false;
      }, 300);
    },

    getColumnWidth(item) {
      if (item.prop === "orgName" || item.label.includes("组织名称")) {
        return "120";
      } else if (item.prop === "driverCount" || item.label.includes("驾驶员总数")) {
        return "100";
      } else if (item.prop === "orgBelowName") {
        return "120";
      } else {
        return "120";
      }
      return null;
    },
    onSearch() {
      // this.currentPage = 1
      this.getData()
    },
    onClear() {
      this.formInline = {
        data: [],
        orgId: '',
      }
      this.getDate()
      this.getData()
    },
    downCar() {
      if (domainName) {
        if (domainName.split(':')[0] !== 'localhost') {
          let url = `https://${domainName}/v1/getExportExcel/exportDriverHomeworkDetails?orgId=${this.formInline.orgId}&startTime=${this.formInline.data[0]}&endTime=${this.formInline.data[1]}&userId=${sessionStorage.getItem("userId")}`
          location.href = url
        } else {
          let host = 'localhost:8080'
          let url = `https://${host}/v1/getExportExcel/exportDriverHomeworkDetails?orgId=${this.formInline.orgId}&startTime=${this.formInline.data[0]}&endTime=${this.formInline.data[1]}&userId=${sessionStorage.getItem("userId")}`
          location.href = url
        }
      }
    }
  },
};
